<template>
  <v-dialog v-model="open" attach=".app-box" max-width="800px" persistent>
    <v-card v-if="item">
      <v-toolbar dark flat style="background-color: var(--dark);">
        <v-toolbar-title>{{ type_title }}</v-toolbar-title>
        <v-spacer />
      </v-toolbar>
      <v-divider />
      <v-container grid-list-md>
        <v-layout wrap>
          <v-text-field v-model="item.name" box label="Titel" />
        </v-layout>

        <file-upload-card :reset="open" @change="changeFiles" />
      </v-container>

      <v-card-actions>
        <v-spacer />
        <v-btn depressed flat @click="close()">
          Close
        </v-btn>
        <v-btn depressed flat @click="save()">
          Speichern
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// import DocumentService from '@/services/modules/document'
import FileUploadCard from '@/components/cards/file-upload';
import { mapState } from 'vuex';
import _ from 'lodash';
import {
  HIDE_RESOURCE_MODAL,
  UPDATE_CFE,
  UPDATE_DOCUMENT,
  UPDATE_STORE_DOCUMENT,
  UPDATE_STORE_CFE
} from '@/config/constants';

export default {
  components: {
    FileUploadCard
  },
  data() {
    return {
      files: []
    };
  },
  computed: {
    ...mapState('navigation', {
      open: state => state.modals.resource.open,
      resource_item: state => state.modals.resource.item,
      type: state => state.modals.resource.type
    }),
    ...mapState('product', {
      product: state => state.selected.product,
      country: state => state.selected.country
    }),
    type_title() {
      if (this.type == 'document') {
        return 'Dokument';
      } else if (this.type == 'cfe') {
        return 'CFE';
      } else {
        return 'Resource';
      }
    },
    item() {
      return this.resource_item ? _.cloneDeep(this.resource_item) : { name: '' };
    }
  },
  methods: {
    close() {
      this.$store.dispatch(HIDE_RESOURCE_MODAL);
    },
    changeFiles(files) {
      this.files = files;
    },
    create() {
      const { DocumentsService } = require('@/services/modules/documents');
      const upload = this.files.map(file => {
        let data = new FormData(),
          docs = new DocumentsService();
        data.append('file', file, file.name);
        //
        if (this.type === 'document') {
          data.append('type', 'document');
          data.append('isArchived', false);
          data.append('archiveType', '');
        } else if (this.type == 'cfe') {
          data.append('type', 'cve');
        }
        data.append('productId', this.product._id);
        data.append('country', this.country);
        data.append('name', this.item.name);
        //
        let update = this.type == 'document' ? UPDATE_STORE_DOCUMENT : UPDATE_STORE_CFE;
        return docs.upload(data).then(doc => {
          this.$store.dispatch(update, doc);
          this.close();
        });
      });
    },
    update() {
      const { DocumentsService } = require('@/services/modules/documents');

      let item = this.item,
        data = new FormData(),
        docs = new DocumentsService();
      //Object.keys(item).forEach((key) => data.append(key, item[key]));
      data.append('name', this.item.name);
      // single file
      this.files.forEach(file => {
        data.append('file', file, file.name);
      });
      let update = this.type == 'document' ? UPDATE_STORE_DOCUMENT : UPDATE_STORE_CFE;
      docs.updateUpload(item, data).then(doc => {
        this.$store.dispatch(update, doc);
        this.close();
      });
    },
    save() {
      if (this.item && this.item._id) {
        this.update();
      } else {
        this.create();
      }
    }
  }
};
</script>

<style>
.dropzone {
  width: 100%;
  height: 200px;
  position: relative;
  display: grid;
  background-color: var(--light-form-bg);
  justify-content: center;
  align-items: center;
  border: 5px dashed var(--light-form-bg);
}

.inner-dropzone {
  height: 100%;
  width: 100%;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  margin: 0px auto;
}
</style>
